<template>
  <div class="header">
      <div class="logo">
        <img :src="require('@/assets/logo.png')" />
      </div>
      <div class="topnav">
        <el-menu
          class="el-menu-demo"
          mode="horizontal"
          text-color="#333"
          style="margin-left:210px"
        >
          <el-submenu index="2" style="float:right;">
            <template slot="title">
              <i class="el-icon-s-custom" />
              {{ $store.state.userinfo.realname }}
              <span style="color:#4FC08D">（{{ $store.state.userinfo.role_name }}）</span>
            </template>
          <!--   <el-menu-item @click.native="personal">
              <i class="el-icon-s-tools" />
              个人中心
            </el-menu-item> -->
            <el-menu-item @click.native="logout">
              <i class="el-icon-switch-button" />
              退出
            </el-menu-item>
          </el-submenu>
         <!--  <el-menu-item style="float:right;" @click="clearCache">
            <i class="el-icon-refresh" />
            更新缓存
          </el-menu-item>
          <el-menu-item style="float:right;" @click="visiteWebsite">
            <i class="el-icon-s-home" />
            网站首页
          </el-menu-item> -->
        </el-menu>
      </div>
  </div>
</template>

<script>
export default {
    data() {
      return {
        activeIndex: '1',
        activeIndex2: '1'
      };
    },
    methods: {
      logout() {
        this.$confirm('确定退出吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            localStorage.removeItem('ats_admintoken')
            this.$store.dispatch('doLogin',false)
            this.$router.push(`/login`)
          })
          .catch(() => {})
      },
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>
<style scoped>
.logo{
  width:140px;
  height:50px;
  float: left;
}
.logo img{
  width: 120px;
  height: 40px;
  margin-top: 5px;
}
.topnav{
  float: right;
  height: 49px;
}
::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title{
  height: 49px;
  line-height: 49px;
}
::v-deep .el-menu.el-menu--horizontal{
  border-bottom: 0;
}
::v-deep .el-menu--horizontal>.el-menu-item{
  height: 49px;
  line-height: 49px;
}

</style>